import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);

  const login = useCallback(async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); if (!data.twofa_required) setUser(data); return data; }, []);
  const loginTwoFA = useCallback(async (challenge, code, kind) => { const { data } = await api.post("/auth/login/2fa", { challenge, code, kind }); setUser(data); return data; }, []);
  const register = useCallback(async (body) => { const { data } = await api.post("/auth/register", body); setUser(data); return data; }, []);
  const refresh = useCallback(async () => { const { data } = await api.get("/auth/me"); setUser(data); return data; }, []);
  const logout = useCallback(async () => { await api.post("/auth/logout"); setUser(false); }, []);

  const value = useMemo(() => ({ user, login, loginTwoFA, register, logout, refresh }), [user, login, loginTwoFA, register, logout, refresh]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
